(function() { window.GUID_ef0ce4f7_3352_4858_93af_41fce466ad1f = { getGuid: function() { return "ef0ce4f7-3352-4858-93af-41fce466ad1f"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Coin extends CS.Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            constructor(controlId, ...params) {
                super(controlId, ...params);
                this.container = this.$Control[0];
                // Guard clause to protect against undefined container
                if (!this.container) {
                    console.error(`Coin control container not found for ID: ${controlId}`);
                    return;
                }
                this.initializeThreeJS();
                // ... rest of initialization
            }
            initializeThreeJS() {
                if (!this.container)
                    return; // Additional safety check
                this.scene = new THREE.Scene();
                this.scene.background = new THREE.Color(0x2b2a33);
                this.camera = new THREE.PerspectiveCamera(75, this.container.clientWidth / this.container.clientHeight, 0.1, 1000);
                this.renderer = new THREE.WebGLRenderer();
                this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
                this.container.appendChild(this.renderer.domElement);
                this.addLights();
                this.addCoin();
                this.initialCameraZ = this.camera.position.z;
                this.adjustCamera();
                this.animate = this.animate.bind(this);
                this.animationFrameId = null;
                this.isFlipping = false;
                this.swingPhase = 0;
                window.addEventListener("resize", () => {
                    this.onWindowResize();
                    this.adjustCamera();
                });
                this.startDefaultAnimation();
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.headsTextureSrc = params[1];
                this.tailsTextureSrc = params[2];
            }
            OnBindEvents() { }
            OnDispose() {
                try {
                    this.stop();
                    // Dispose of the coin geometry and materials
                    if (this.coin) {
                        this.coin.geometry.dispose();
                        this.coin.material.forEach((material) => {
                            if (material.map) {
                                material.map.dispose();
                            }
                            material.dispose();
                        });
                        this.scene.remove(this.coin);
                    }
                    // Dispose of lights
                    this.scene.children.forEach((child) => {
                        if (child instanceof THREE.Light) {
                            this.scene.remove(child);
                        }
                    });
                    // Dispose of the renderer
                    this.renderer.dispose();
                    // Remove renderer's DOM element
                    if (this.renderer.domElement.parentNode) {
                        this.renderer.domElement.parentNode.removeChild(this.renderer.domElement);
                    }
                }
                catch (error) {
                    console.error("Error while disposing the control: ", error);
                }
            }
            OnControlRendered() { }
            addLights() {
                const light = new THREE.DirectionalLight(0xffffff, 1.5);
                light.position.set(5, 5, 5).normalize();
                this.scene.add(light);
                const ambientLight = new THREE.AmbientLight(0xffffff);
                this.scene.add(ambientLight);
            }
            addCoin() {
                const loader = new THREE.TextureLoader();
                loader.setCrossOrigin("anonymous");
                // Load textures
                const headsTexture = loader.load(this.headsTextureSrc);
                headsTexture.center.set(0.5, 0.5); // Center the texture for rotation
                headsTexture.rotation = Math.PI / 2; // Rotate by 90 degrees
                const tailsTexture = loader.load(this.tailsTextureSrc);
                tailsTexture.center.set(0.5, 0.5); // Center the texture for rotation
                tailsTexture.rotation = -Math.PI / 2; // Rotate by -90 degrees
                // Materials for the two faces and the edge
                const headsMaterial = new THREE.MeshStandardMaterial({
                    map: headsTexture,
                    // color: 0x0000ff, // blue color
                });
                const tailsMaterial = new THREE.MeshStandardMaterial({
                    map: tailsTexture,
                    // color: 0xff0000, // red color
                });
                const edgeMaterial = new THREE.MeshStandardMaterial({
                    color: 0xf9f8f6, // Use the specified edge color
                    metalness: 0.5,
                    roughness: 0.5,
                });
                // Coin geometry
                const geometry = new THREE.CylinderGeometry(1, 1, 0.1, 32);
                // Apply materials to faces: [edge, heads, tails]
                const materials = [edgeMaterial, headsMaterial, tailsMaterial];
                this.coin = new THREE.Mesh(geometry, materials);
                this.scene.add(this.coin);
                // Position the coin vertically
                this.coin.rotation.x = Math.PI / 2;
            }
            adjustCamera() {
                // Actual size of the coin (radius = 1, diameter = 2)
                const coinDiameter = 2; // The size of the coin's diameter
                // Get the smallest dimension (width or height) to adjust the camera
                const minDimension = Math.min(this.container.clientWidth, this.container.clientHeight);
                // We want the coin to occupy 90% of this dimension
                const viewSize = minDimension * 0.9;
                // Calculate the camera distance so the coin occupies 90% of the smallest dimension
                const fovRadians = THREE.MathUtils.degToRad(this.camera.fov);
                let distance = coinDiameter / 2 / Math.tan(fovRadians / 2);
                // Move the camera back further, say 30%
                distance *= 1.3; // Adjust this factor to move back further
                this.camera.position.z = distance;
                this.initialCameraZ = distance; // Update the initial position of the camera
                this.camera.aspect =
                    this.container.clientWidth / this.container.clientHeight;
                this.camera.updateProjectionMatrix();
            }
            startDefaultAnimation() {
                this.animate();
            }
            animate() {
                if (this.animationFrameId !== null) {
                    cancelAnimationFrame(this.animationFrameId);
                }
                this.animationFrameId = requestAnimationFrame(this.animate);
                if (!this.isFlipping) {
                    // Default swinging motion around the Z-axis
                    this.swingPhase += 0.025; // Adjust for controlling the swing speed
                    this.coin.rotation.z = 0.1 * Math.sin(this.swingPhase); // Adjust the swing amplitude
                }
                this.renderer.render(this.scene, this.camera);
            }
            flip(target = null) {
                if (this.isFlipping) {
                    return; // Do nothing if a flip is already in progress
                }
                // Determine the flip target if not specified
                if (target === null) {
                    target = Math.random() > 0.5 ? "heads" : "tails";
                }
                // Set rotation targets for heads and tails
                const xTarget = target === "heads" ? Math.PI / 2 : -Math.PI / 2;
                this.startFlipAnimation(xTarget, 0);
            }
            easeInOutQuad(t) {
                return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
            }
            startFlipAnimation(xTarget, zTarget) {
                this.stop();
                this.isFlipping = true;
                let progress = 0;
                const duration = 360; // Increase duration for more turns
                const initialX = this.coin.rotation.x;
                const initialZ = this.coin.rotation.z;
                // Add multiple turns to the animation
                const extraTurns = 16 * Math.PI; // 4 full additional turns
                const flipAnimation = () => {
                    if (progress < duration) {
                        this.animationFrameId = requestAnimationFrame(flipAnimation);
                        progress++;
                        const t = progress / duration;
                        const easedT = this.easeInOutQuad(t); // Apply easing
                        // Adjust rotation
                        this.coin.rotation.x =
                            initialX + extraTurns * easedT + (xTarget - initialX) * easedT;
                        this.coin.rotation.z = initialZ + (zTarget - initialZ) * easedT;
                        // Adjust camera position
                        const halfway = 0.5;
                        const maxCameraDistance = this.initialCameraZ * 2; // Move back 100% more
                        if (t < halfway) {
                            // Moving away phase
                            const easedTOut = this.easeInOutQuad(t / halfway); // Normalize t for the first half
                            this.camera.position.z =
                                this.initialCameraZ +
                                    (maxCameraDistance - this.initialCameraZ) * easedTOut;
                        }
                        else {
                            // Returning phase
                            const easedTIn = this.easeInOutQuad((t - halfway) / halfway); // Normalize t for the second half
                            this.camera.position.z =
                                maxCameraDistance -
                                    (maxCameraDistance - this.initialCameraZ) * easedTIn;
                        }
                        this.renderer.render(this.scene, this.camera);
                    }
                    else {
                        this.isFlipping = false; // Flip completed
                        this.coin.rotation.x = xTarget; // Ensure the coin remains in the final position
                        this.coin.rotation.z = zTarget;
                        this.camera.position.z = this.initialCameraZ; // Restore the camera position
                        this.swingPhase = Math.asin(this.coin.rotation.z / 0.1); // Sync with the default animation
                        this.startDefaultAnimation();
                        this.$Control.trigger("coin-flipped", [
                            xTarget === Math.PI / 2 ? "heads" : "tails",
                        ]);
                    }
                };
                flipAnimation();
            }
            onWindowResize() {
                this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
                this.adjustCamera();
            }
            stop() {
                if (this.animationFrameId !== null) {
                    cancelAnimationFrame(this.animationFrameId);
                    this.animationFrameId = null;
                }
            }
        }
        Controls.Coin = Coin;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=coin.js.map
